// SplitListPanel hooks
export type { TabPanelOptions, UsePanelActionsReturn } from './usePanelActions';
export type {
  ReconcileStrategy,
  UseReconcileTabsOptions,
  UseReconcileTabsReturn,
} from './useReconcileTabs';

// Phase 5: usePanelActions (Public API)
export { usePanelActions } from './usePanelActions';
// Tab reconciliation hooks
export { useReconcileTabs, useTabAccessTracker } from './useReconcileTabs';
// SplitDetailPanel hooks
export {
  useSplitDetailPanelContext,
  useSplitDetailPanelSelector,
  // Phase 6: 새 이름
  useTabPanelActionStoreInternal,
  // Phase 6: 레거시 별칭 (deprecated)
  useSplitDetailPanelActions,
  useSplitDetailPanelTabs,
  useSplitDetailPanelActiveTabKey,
  useSplitDetailPanelActiveTab,
  useSplitDetailPanelVisible,
  useSplitDetailPanelTabCount,
  useSplitDetailPanelMaxTabs,
  useSplitDetailPanelCanAddTab,
  useSplitDetailPanelDerivedState,
} from './useSplitDetailPanelStore';
export {
  useSplitListPanelContext,
  useSplitListPanelSelector,
  useSplitListPanelActions,
  useSplitListPanelDerivedState,
  useSplitListPanelPreferences,
  useSplitListPanelLayoutGuard,
  useSplitListPanelSelectedIds,
  useSplitListPanelFocusedId,
} from './useSplitListPanelStore';
